module.exports = __webpack_public_path__ + "img/37.5f87224c.jpg";